<template>
  <!-- 用户意见反馈 -->
  <div>
    <div class="page_title">业务员意见反馈</div>
    <div style="padding:20px;">
      <div class="container">
        <!-- 筛选项 -->

        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">提交日期</div>
            <el-date-picker size="small"
                            v-model="submitTime"
                            type="daterange"
                            range-separator="~"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="search" />
          </div>
          <div class="box flex">
            <div class="label">业务员姓名</div>
            <el-input v-model="queryData.recommender_name"
                      size="small"
                      style="width:140px"
                      clearable
                      @input="search" />
          </div>
          <div class="box flex">
            <div class="label">联系电话</div>
            <el-input v-model="queryData.phone"
                      size="small"
                      style="width:200px"
                      clearable
                      @input="search" />
          </div>

          <el-button type="primary"
                     class="search-button"
                     clearable
                     @click="search"
                     size="small">查询</el-button>
        </div>
        <!-- 表格 -->
        <div style="border: solid 1px #c9cbd6;">
          <el-table ref="multipleTable"
                    :data="feedbackTableData"
                    tooltip-effect="dark"
                    style="width: 100%;min-width:1000px;"
                    :header-cell-style="{background:'#F5F5F5'}">
            <el-table-column label="提交日期"
                             align="center"
                             prop="create_time" />

            <el-table-column label="业务员姓名"
                             align="center"
                             prop="recommender_name">
            </el-table-column>

            <el-table-column label="联系电话"
                             align="center"
                             prop="phone">
            </el-table-column>

            <el-table-column label="意见反馈"
                             align="center"
                             prop="content"
                             width="600px" />

          </el-table>
        </div>
        <div>
          <pagination v-show="totalNum>0"
                      :total="totalNum"
                      :page.sync="pagination.page"
                      :limit.sync="pagination.pageNumber"
                      @pagination="searchList" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import Pagination from '../../../components/Pagination/index';
import activity from '../../../api/activity';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      queryData: {
        recommender_name: '',
        phone: ''
      },
      submitTime: [],
      pagination: {
        page: 1,
        pageNumber: 10
      },
      totalNum: 0,
      feedbackTableData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //获取认证记录列表
    getList() {
      let params = Object.assign(this.queryData, this.pagination);
      if (this.submitTime && this.submitTime.length > 0) {
        params.submit_start_time = this.submitTime[0];
        params.submit_end_time = this.submitTime[1];
      } else {
        params.submit_start_time = '';
        params.submit_end_time = '';
      }
      activity.getRecommenderFeedbackList(params).then((res) => {
        let { data } = res;
        let list = data.list;
        list.forEach((ele) => {
          ele.create_time = moment.unix(ele.create_time).format('YYYY-MM-DD');
        });
        this.totalNum = data.total;
        this.feedbackTableData = list;
      });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },
    searchList() {
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  line-height: 32px;
  height: 32px;
  margin-bottom: 20px;
  .box {
    line-height: 32px;
    height: 32px;
    margin-right: 20px;
    .label {
      margin-right: 10px;
    }
  }
  // .search-button {
  // background-color: #eceff2;
  // color: #747981;
  // }
}
</style>
<style lang="scss">
.el-image > img {
  height: 100px;
  width: auto;
  display: block;
}
.el-image-viewer__close {
  i {
    color: #ffffff;
  }
}
</style>


